// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o5-1";
export var stateContainer = "_o5-0";